var NextDaySCCookies;
(function (NextDaySCCookies) {
    // Value must match the actual browser cookie name set by the web app (lowercase
    NextDaySCCookies["COUNTRY"] = "country";
})(NextDaySCCookies || (NextDaySCCookies = {}));
var USER_PERMISSIONS;
(function (USER_PERMISSIONS) {
    USER_PERMISSIONS["Context_3k"] = "3K_context";
    USER_PERMISSIONS["Context_4k"] = "4K_context";
    USER_PERMISSIONS["Context_8k"] = "8K_context";
    USER_PERMISSIONS["SiteAccess"] = "site_access";
    USER_PERMISSIONS["ViewChats"] = "view_chats";
    USER_PERMISSIONS["ViewHelp"] = "view_help";
    USER_PERMISSIONS["ViewMyChatBots"] = "view_my_chat_bots";
    USER_PERMISSIONS["ReportCharacter"] = "report_character";
    USER_PERMISSIONS["CreateCharacter"] = "create_character";
    USER_PERMISSIONS["DeleteCharacter"] = "delete_character";
    USER_PERMISSIONS["DisplayAds"] = "display_ads";
})(USER_PERMISSIONS || (USER_PERMISSIONS = {}));
export { NextDaySCCookies, USER_PERMISSIONS };
